import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenerateFormService, PerForm } from '@lbmx/per-form';
import {
  SpinnerService,
  ToastrNotificationService,
} from '@lbmx/phoenix-lib-utils';
import { BaseHttpService } from '@lbmx/web-core';
import { TranslocoService } from '@ngneat/transloco';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { schemaDefinition } from './add-option.ui';

@Component({
  selector: 'lib-add-option-container',
  template: ` <lib-add-option
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="save($event)"
  ></lib-add-option>`,
  styles: ['body .ui-dialog .ui-dialog-content { overflow-auto; }']
})
export class AddOptionContainerComponent implements OnInit {
  @Input() public baseUrl: string;
  @Output() public closeDialog = new EventEmitter();
  @Output() public updateAddOption = new EventEmitter();

  public form: PerForm;
  public schemaDefinition = schemaDefinition;
  public currentFormValues;
  constructor(
    private http: BaseHttpService,
    private spinner: SpinnerService,
    private translocoService: TranslocoService,
    private toast: ToastrNotificationService,
    private formGenerator: GenerateFormService
  ) {}

  public ngOnInit(): void {
    this.http
      .fetchWithFqn({
        endpoint: `${this.baseUrl}` + '/add-option/form',
        httpMethod: 'GET',
      })
      .pipe(
        tap(({ fields }: any) => {
          this.form = this.formGenerator.init(
            this.schemaDefinition(fields),
          );
        }),
        catchError(() =>
          of(
            this.toast.errorNotify(
              this.translocoService.translate('MESSAGES.GENERIC_ERROR')
            )
          )
        )
      )
      .subscribe();
  }

  public save(formValues: any) {
    this.spinner.on();
    this.http
      .fetchWithFqn({
        endpoint: `${this.baseUrl}/add-option`,
        httpMethod: 'POST',
        body: formValues,
      })
      .pipe(
        tap((response: any) => {
          this.toast.successNotify(
            this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
          );
          this.closeDialog.emit();
          this.updateAddOption.emit();
        }),
        catchError((error: any) => {
        if (error?.error?.errorCode === 3 || error?.error?.errorCode === 'AlreadyExist') {
          return of(
            this.toast.errorNotify(
              this.translocoService.translate('ANALYTICS.TOAST_RECORD_ALREADY_EXIST')
            )
          );
        } else {
          return of(
            this.toast.errorNotify(
              this.translocoService.translate('MESSAGES.GENERIC_ERROR')
            )
          );
        }
      }),
      finalize(() => this.spinner.off())
    )
      .subscribe();
  }
}
